import React from 'react';
import { createHashRouter, RouterProvider } from 'react-router-dom';
// import PageProToolIndex from '../pages';
import PageProject from '../pages/project';

const router = createHashRouter([
  // {
  //   path: '/project',
  //   element: <PageProToolIndex />,
  // },
  {
    path: '/',
    element: <PageProject />,
  },
]);

export default () => {
  return <RouterProvider router={router} />;
};
